import { Record } from 'immutable';

export default class BasicSchema extends Record({
  id: undefined,
  createdAt: undefined,
  createdBy: undefined,
  items: undefined,
  links: undefined,
  validFrom: undefined,
}) {
}
